/**
 * API Configuration
 * Manages API base URL for different environments
 */

// In production (when built), use empty string for relative URLs
// In development, use proxy (empty string) or environment variable
const API_URL = process.env.NODE_ENV === 'production' 
  ? '' 
  : (process.env.REACT_APP_API_URL || '');

export default API_URL;
